import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from './msalConfig';

/**
 * Acquire an access token for a specific set of scopes (per-agent).
 * Uses acquireTokenSilent first, falls back to acquireTokenPopup
 * if user interaction is required (e.g., consent, MFA).
 */
export async function getAccessTokenForAgent(scopes: string[]): Promise<string> {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    throw new Error('No authenticated account. Please sign in.');
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes,
      account: accounts[0],
    });
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      const response = await msalInstance.acquireTokenPopup({ scopes });
      return response.accessToken;
    }
    throw error;
  }
}

/**
 * Acquire an access token for Microsoft Graph (user profile).
 */
export async function getGraphToken(): Promise<string> {
  return getAccessTokenForAgent(['User.Read']);
}
